export default __webpack_public_path__ + "static/media/email.b57c63e2.png";